module.exports = __webpack_public_path__ + "img/body-1-lg.bcd5d49f.png";